import React from "react";
import { Container } from "react-bootstrap";

export const Customers: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Customers......
            </Container>
        </React.Fragment>
    );
}